import React from "react";

const steps = [
  {
    n: "01",
    t: "Discovery Call",
    d: "30 minutes. We learn about your assets, business, and tax posture, and tell you whether a study makes sense.",
  },
  {
    n: "02",
    t: "Feasibility & Proposal",
    d: "We model expected savings (free) and send a fixed-fee proposal with timeline and deliverables.",
  },
  {
    n: "03",
    t: "Engineering Study",
    d: "Our engineers analyze blueprints, invoices, and site data — and (for cost seg) walk the property.",
  },
  {
    n: "04",
    t: "Deliverables to CPA",
    d: "Audit-ready report, asset schedule, technical narrative, and form-ready depreciation tables.",
  },
  {
    n: "05",
    t: "Realized Savings",
    d: "Your CPA applies the credit / deduction. You see the savings on your next return — and we're here on audit.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 sm:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="mb-16 max-w-3xl">
          <p className="text-forest-600 uppercase tracking-[0.24em] text-sm mb-4">
            How it works
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-forest-950 leading-[1.05] tracking-tight">
            From first call to <span className="italic text-brass">realized savings</span> — usually in 30 to 60 days.
          </h2>
        </div>

        <ol className="grid md:grid-cols-2 lg:grid-cols-5 gap-px bg-ivory-400 border border-ivory-400">
          {steps.map((s) => (
            <li
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="bg-ivory p-8 hover:bg-white hover:-translate-y-1 transition-all duration-300"
            >
              <div className="font-serif text-5xl text-brass mb-4">{s.n}</div>
              <h3 className="font-serif text-2xl text-forest-950 mb-3">{s.t}</h3>
              <p className="text-forest-800 leading-relaxed text-sm">{s.d}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
